
app.pagesController = app.pagesController || {};
app.pagesController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    home : function () {
        var $heroLinkHref = $(".heroLinkHref");

        $heroLinkHref.on('mouseover', function(e) {
            var $activeHero = $(e.target).hasClass('heroMask') ? $(e.target) : $(e.target).parents('.heroMask');

            $activeHero.addClass('is-hover');
            $(".heroMask:not(.is-hover)").removeClass('is-hover').addClass('is-not-hover');
        });

        $heroLinkHref.on('mouseout', function(e) {
            var $activeHero = $(e.target).hasClass('heroMask') ? $(e.target) : $(e.target).parents('.heroMask');
            $activeHero.removeClass('is-hover');
            $('.heroMask').removeClass('is-not-hover');
        });

        $heroLinkHref.on('click', function(e) {
            e.preventDefault();
            var $activeHero = $(e.target).hasClass('heroMask') ? $(e.target) : $(e.target).parents('.heroMask');

            $activeHero.addClass('is-clicked');
            $(".heroMask:not(.is-clicked)").removeClass('is-clicked').addClass('is-not-clicked');

            setTimeout(function() {
                var activeUrl = $activeHero.find('.heroLinkHref').attr('href');
                window.location.href = activeUrl;
                $('.siteBody').addClass('is-loading');
            }, 1500);
        });

        $(window).bind("pageshow", function() {
            $('.siteBody').removeClass('is-loading');
            $(".heroMask").removeClass('is-hover is-not-hover is-clicked is-not-clicked');
        });
    },

    actualites : function () {
        $(".siteMain .newsList").masonry({
            // options...
            itemSelector: '.newsItem',
            columnWidth: '.newsItem',
            gutter: 20,
            percentPosition: false
        });
    },

    carte : function () {

    },

    singleActu : function () {
        if ($("#newsGallery").length > 0) {
            $("#newsGallery").unitegallery({
                tiles_type:"justified"
            });
        }
    },

    reserver : function () {
        if ($(".fld-allergie").length > 0) {
            var $allerRadio = $('.fld-allergie').find('input[type=radio]'),
                $allerText = $('#fld-allergie-detail');

            $activeRadio = $($('.fld-allergie').find('input[type=radio]:checked'));
            if ($activeRadio.val() == 'Oui') {
                $allerText.addClass('is-active');
            }

            $allerRadio.on('change', function(){
                if (this.value == 'Oui') {
                    $allerText.addClass('is-active wpcf7-validates-as-required').attr('aria-required', true);
                }
                else {
                    $allerText.removeClass('is-active wpcf7-validates-as-required').attr('aria-required', false).removeAttr('aria-invalid').val('');
                }
            });
        }
    },
        
};

$(document).ready(function(){

    // Home page
    if ($('body').hasClass('home')) {
        app.pagesController.defaultAction.home();
    }

    // Page La carte
    if ($('body').hasClass('la-carte')) {
        app.pagesController.defaultAction.carte();
    }

    // Page actus
    if ($('body').hasClass('actualites')) {
        app.pagesController.defaultAction.actualites();
    }

    // Page détail actu
    if ($('body').hasClass('single-post')) {
        app.pagesController.defaultAction.singleActu();
    }

    // Page détail réserver
    if ($('body').hasClass('reserver')) {
        // app.pagesController.defaultAction.reserver();
    }
});
